<optsol-ngx-spinner></optsol-ngx-spinner>
<optsol-ngx-top-nav [showContextDropdown]="false" [contexts]="contexts" [selectedContext]="selectedContext" [menuItems]="menu" [user]="user"
    (menuItemClicked)="menuItemClicked($event)" (togglerClicked)="toggleSideMenu()">
    <img brandImage [src]="environmentSettings.portalLogoUrl" class="logo"/>

    <ng-container environment>
      <span *ngIf="environmentSettings.showEnvironmentName" class="mat-h4">{{environmentSettings.environmentName}}</span>
    </ng-container>


    <ng-container info>
      <div style="display: flex;flex-direction: row;align-content: center;justify-content: center;align-items: flex-start;">
        <div style="display: flex;flex-direction: column;flex-wrap: nowrap;align-content: center;justify-content: center;align-items: center;margin: 0px 32px 0px 32px;">
          <div style="font-size: 9pt;">Logged in user</div>
          <div style="margin-top: -12px;font-size: 12pt;">{{user?.userDisplayName}}</div>
        </div>
        <div style="display: flex;height: 100%;margin-top: 13px;margin-right: 32px;">
          <button mat-icon-button (click)="getUserInfo()">
            <mat-icon>help</mat-icon>
          </button>
        </div>

      </div>
    </ng-container>

</optsol-ngx-top-nav>
<mat-sidenav-container class="os-sidenav-container">
    <mat-sidenav [(opened)]="sideMenuVisible" mode="slide">
        <optsol-ngx-side-menu *ngIf="data" [data]="data" [compactView]="true" [collapsedOnStartup]="true">
            <img poweredByImage [src]="environmentSettings.poweredByUrl" width="30%" />
            <ng-container environment>V{{versionCode}}</ng-container>
        </optsol-ngx-side-menu>
    </mat-sidenav>
    <mat-sidenav-content class="os-sidenav-content os-pt1 os-pl1 os-pr1">
        <router-outlet></router-outlet>
    </mat-sidenav-content>
</mat-sidenav-container>

<optsol-ngx-version-checker [interval]="interval" [endpoint]="versionCheckerUrl" [applicationCode]="applicationCode" [versionCode]="versionCode" (forceLogout)="logout()"></optsol-ngx-version-checker>
